import styled from "styled-components";

const Dropdown = styled.span`
  cursor: pointer;
  position: relative;
  }
  .dropdown-list {
    background: ${props => props.theme.primary.darkGrey};
    padding: 10px;
    border-radius: 4px;
    li {
      cursor: pointer;
      & + li {
        border-top: 1px solid ${props => props.theme.dark.slateGrey};
        margin-top: 5px;
        padding-top: 5px;
      }
    }
  }
`;

const DropdownMenu = styled.div`
  ${"" /* display: none; */}
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  // min-width: 184px;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-4px);
  transition: all 0.2s ease-in-out;
`;

const DropdownButton = styled.div`
  display: inline-block;
  background-color: ${props => props.theme.primary.darkGrey};
  border-radius: 14px;
`;

const Title = styled.span`
  display: inline-block;
  background: transparent;
  border: 0;
  color: var(--color-theme-1);
  font: ${props => props.theme.fontWeight.bold}
    ${props => props.theme.fontSize.sm}px
    ${props => props.theme.fontFamily.sansSerif};
  opacity: 0.7;
  padding: 7px 10px 7px 10px;
  text-transform: uppercase;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
`;

const DropdownIcon = styled.span`
  border-color: ${props =>
    props.isOpen
        ? "transparent transparent #5D636D"
        : "#5D636D transparent transparent;"};
  border-width: ${props => (props.isOpen ? "0 4px 4px" : "4px 4px 0")};
  border-style: solid;
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
`;

const transitionStyles = {
    entered: {
        opacity: 1,
        visibility: "visible",
        transform: "translateY(0)"
    }
};

export {
    Dropdown,
    DropdownMenu,
    DropdownButton,
    Title,
    DropdownIcon,
    transitionStyles
};



// WEBPACK FOOTER //
// ./src/components/layouts/dropdowns/style.js